<template>
 <div class="mapgaode" v-loading="loading">
  <div id="container" class="map_container" tabindex="0" ></div>
  <!-- <div class="input-card">
    <h4>聚合点效果切换</h4>
    <div class="input-item">
        <input type="button" class="btn" value="默认样式" id="add0" onclick='addCluster(0)'/>
        <input type="button" class="btn" value="自定义图标" id="add1" onclick='addCluster(1)'/>
        <input type="button" class="btn" value="完全自定义" id="add2" onclick='addCluster(2)'/>
    </div>
  </div>  -->
 </div>
</template>

<script>
import AmapLoader from "@amap/amap-jsapi-loader";
// import points  from "../utils/points"
//import center  from "../assets/styles/center.scss"
export default {
  name: "Amap",
  props:{
    points: {
      type: Array,
    },
    longitude:{
      type:Number,
    },
    latitude:{
      type:Number,
    },
    input:{
      type:String,
    },
    zoom:{
      type:Number,
    }
  },
  data() {

    return {
      loading:false,
      amapLoader:null,
      amapManager: null,//地图实例
      placeSearch: null,//搜索实例
      // points,
      searchList: [],//查询结果
      currentCity: null,//当前所处城市
      markerRefs: [],//聚合点数据
      markers:[],//标记点数据
      addressPosition:[],
      infoWindow:null, //信息弹窗,
      oldKey:''
    }
  },
  mounted() {
    this.initMap();
    //this.initPlugins();
  },
  watch: {
    points: {
        handler(newVal) {
            this.points = newVal
            this.initMap()
            console.log(this.longitude,'this.longitude')
        },
        deep: true
    },
    longitude: {
        handler(newVal) {
            this.longitude = newVal
            this.initMap()
        },
        deep: true
    },
    latitude: {
        handler(newVal) {
            this.latitude = newVal
        },
        deep: true
    },
    zoom:{
        handler(newVal) {
            this.zoom = newVal
        },
        deep: true
    },

  },
  methods: {
    initMap(){
      this.loading = true
      AmapLoader.load({
        key: "d9c152ce9c12d71e334a497608e8d1ca",
        version: "1.4.15",
        plugins: ['AMap.MarkerClusterer','AMap.Marker','AMap.PlaceSearch','AMap.Autocomplete','misc/PositionPicker'],
      }).then((AMap)=>{
         
         var map = new AMap.Map("container", {
             resizeEnable: true,
             center: [this.longitude, this.latitude],
             zoom: this.zoom,
         });
         this.amapLoader = AMap;
         this.amapManager =  map
         
        // 初始化聚合列表和点的列表
        var cluster,markers = [];
        
        // 循环读取每一个点的经纬度信息
        for (let i = 0; i < this.points.length; i ++ ) {
            //添加点坐标
            let pos = [this.points[i].locationLng,this.points[i].locationLat]
            if(this.points[i].vrType===0){
              //console.log(this.points[i].vrType,'this.points[i].vrType')
            }
            //创建icon
            let img = this.points[i].vrType===0?require("../assets/pointVR1.png"):require("../assets/pointVR2.png")
            //console.log(img,'image.png')
            let addIcon  = new AMap.Icon({
               // 图标尺寸
               size: new this.amapLoader.Size(30, 34),
               // 图标的取图地址
               image: img,
               // 图标所用图片大小
               imageSize: new this.amapLoader.Size(30, 34)
            });

            let marker = new AMap.Marker({
                position: pos,
                icon: addIcon,
                //content: '<div style="background-color: hsla(180, 100%, 50%, 0.7); height: 24px; width: 24px; border: 1px solid hsl(180, 100%, 40%); border-radius: 12px; box-shadow: hsl(180, 100%, 50%) 0px 0px 1px;"></div>',
                offset: new AMap.Pixel(-15, -15),
            })
            // 给marker点坐标添加额外的属性和对应的属性值，圈重点这里是关键
            marker.setExtData(this.points[i].id)
            // 给每个点坐标绑定click事件，这里是实现点击功能的重点
            marker.on('click', this.markerClick)
            markers.push(marker)
            this.infoWindow = new AMap.InfoWindow();

            this.infoWindow.on('click',function(){
                this.infoWindow.close()
            });
            //marker.emit('click', {target: marker});
        } 


        var count = markers.length;
        var _renderClusterMarker = function (context) {
           var size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
           let div = document.createElement('div');
           let img = document.createElement('img');
           img.src = "https://h5.ophyer.cn/wmy/VR/amap_group_icon.png";
           img.style.position = "absolute";
           img.style.top = "20px";
           img.style.left = "50%";
           img.style.width = '60px'
           img.style.transform = "translate(-50%)";
           div.style.position = "relative";
           div.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
           div.style.padding = '1px 8px';
           div.style['white-space'] = 'nowrap';
           div.style.borderRadius = '3px';
           div.innerHTML = context.count;
           div.append(img);
           div.style.color = '#ffffff';
           div.style.textAlign = 'center';

           context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
           context.marker.setContent(div)
        };
        if (cluster) {
            cluster.setMap(null);
        }

        cluster = new AMap.MarkerClusterer(map, markers, {
             gridSize: 80,
             renderClusterMarker: _renderClusterMarker
        });
        this.loading = false
        //this.handlePositionPickerEvent()
        //this.initPlugins();

      })
    },
    
    //拖拽功能
    handlePositionPickerEvent(){
       let that = this;
       that.amapLoader.AMapUI(['misc/PositionPicker'], function (PositionPicker) {
           console.log('拖拽加载成功');
            that.positionPicker = new PositionPicker({
              // mode: 'dragMap',
              mode: 'dragMarker',
              map: that.amapManager
           })
            
         that.positionPicker.on('success', function (positionResult) {
              console.log("拖拽成功")
              if(that.infoWindow){
                that.infoWindow.close()
              }
        })
         that.positionPicker.on('fail', function (positionResult) {
          // 海上或海外无法获得地址信息
        
          })
       })
    },

    //插件设置
    initPlugins(){

      if(!this.amapLoader){
        console.log("map加载失败！")
        return;
      }
      //搜索插件设置
      const placeSearch = new this.amapLoader.PlaceSearch({
        map: this.amapManager,//地图实例
        panel:"searchResultView",//结果列表将在此容器中进行展示
        autoFitView:true,//是否自动调整地图视野使绘制的Marker点都处于视口的可见范围
      });

      const _this = this;
      placeSearch.on("listElementClick",(e)=>{
        const location = e.data.location;
        const position = [location.lng,location.lat];
        _this.addressPosition = position;
      })
      this.placeSearch = placeSearch;
    },

    //关键字搜索
    searchByHand(input) {
      let _this =this
      var autoComplete= new AMap.Autocomplete();
      autoComplete.search(input, function(status, result) {
        if(status === "complete"){
            _this.searchList = result.tips || [];
            _this.$emit('placeSearch',_this.searchList)
        }else {
          console.log("status",status,"result",result);
        }
      })
    },
    //点坐标点击事件，在点聚合功能中以完成绑定
    markerClick (e) {
        console.log(e.target.getExtData())
        // 拿到之前赋予的keyid值，将该值传入获取详细信息的函数
        const keyId = e.target.getExtData()   
        if(this.infoWindow && this.infoWindow.getIsOpen() && this.oldKey===keyId){
           this.infoWindow.close()
    
        }
        else{
          // 调用获取详细信息的函数
          this.getDesMessage(keyId,e)
        }
    },
      
    //构建自定义窗体
	  createInfoWindow(item) {
	     let inf = document.createElement("div");
	     inf.className = "amap-icon1"
	     var body = document.createElement("div"); 
       var div = document.createElement("div")          
	     var a = document.createElement("a"); 
       let VRicon = item.vrType===0?'https://ophyer-1253267589.cos.ap-chengdu.myqcloud.com/official_website/other/VRimg.png':'https://ophyer-1253267589.cos.ap-chengdu.myqcloud.com/official_website/other/VRvideo.png'
       a.innerHTML = "<div class='img_box' id='info_box'><img src='"+item.coverImage+"' />"+
                           "<div class='vrimgicon'><img src='"+VRicon+"'></div>"+
                           "<div class='wenzi_box'>"+
                            "<h2>"+item.viewName+"</h2>" +
                            "<div class='sub'><img src='https://ophyer-1253267589.cos.ap-chengdu.myqcloud.com/official_website/other/daohang.png' style='width:12px;height: 12px;'/>"+
                              "<span>"+item.cityName+"</span></div>" +
                            "<div class='line'></div>" +
                            "<p>"+item.authorName+"</p>" +
                           "</div></div>" 
       a.href = item.linkUrl
       a.style.textDecoration = 'none' 
       a.target="_blank"
       body.appendChild(a)
	     inf.appendChild(body);
         
	     return inf;
    },

    // 获取详细弹窗
    getDesMessage (keyId,e) {
        this.oldKey =  keyId 
        console.log(e.target.getPosition(),'e.target.getPosition()')
        this.loading = true
        let devurl = '/api/city/view/getById?id='+keyId
        //let url = process.env.NODE_ENV==='development'?  devurl:(process.env.VUE_APP_NODE_ENV==='test'?'https://test.iwmy.igame123.com/apiProxy/city/view/all':'https://i.wmy.ophyer.com/apiProxy/city/view/all')
        this.$axios.get(devurl).then((res) =>{   
            console.log(res.data.data,'res.data.data')
            var _this = this
            _this.infoWindow = new AMap.InfoWindow({
                   offset: new AMap.Pixel(0, -20),
                   closeWhenClickMap:true,
                   retainWhenClose: true
            });
            _this.infoWindow.setContent(_this.createInfoWindow(res.data.data));
           
            setTimeout(function(){
                _this.infoWindow.open(_this.amapManager, e.target.getPosition())  

            },400);
           
            _this.amapManager.setCenter(e.target.getPosition());//设置地图放大级别及居中
            _this.amapManager.panBy(0, 100);
            _this.loading = false
        })
    },
    open(){
        alert('hello world')
    },
    //跳转链接
    handellink(item){
      alert('hello world')
      //this.$router.push({path:'/details',query:{item:item}})
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .amap-info-content{
    padding: 0;
    border-radius: 5px;
  }
  html, body, #container {
     height: calc(100vh - 55px); 
  }
  ::v-deep .amap-marker .amap-marker-content{
    div{
       background: #FFFFFF !important;
       box-shadow: 0px 3px 5px 0px rgb(0 0 0 / 6%) !important;
       border-radius: 5px !important;
       padding: 3px 10px !important;
       font-size: 13px !important;
       font-family: DINAlternate-Bold, DINAlternate !important;
       font-weight: bold !important;
       color: #303234 !important;
       line-height: 15px !important;
    }
  }
  ::v-deep .img_box{
       // margin: 15px auto 0;
       width: 250px;
       // height: 220px;
       background: #FFFFFF;
       border-radius: 5px;
       img{
          width: 250px;
          object-fit: cover;
          height: 125px;
          border-radius: 5px 5px 0 0;
       }
       .vrimgicon{
          position: absolute;
          top: 50px;
          left: 113px;
          img{
             width: 24px;
             height: 24px;
          }
       }
       .wenzi_box{
         margin-left: 10px;
         margin-top: -10px;
          .sub{
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #989EA6;
              margin-top: -6px;
              text-align: left
          }
          .line{
            margin-top: 8px;
            width: 230px;
            height: 1px;
            background: #E8E9EC;
            border-radius: 2px;
          }
          p{
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #989EA6;
            line-height: 12px;
            text-align: left
          }
          h2{
            white-space: nowrap;// 文字不换行
            overflow: hidden;// 超出隐藏
            text-overflow: ellipsis;
            width: 230px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 20px;
            text-align: left;
         }
       } 
   }
   ::v-deep .amap-info-close{
     display: none;
     position: absolute;
     right: 5px !important;
     top: 9px;
     color: #333;
     text-decoration: none;
     font: bold 16px/14px Tahoma,Verdana,sans-serif;
     width: 30px;
     height: 30px;
     font-size: 23px;
   }
  // ::v-deep .amap-logo,.amap-copyright{
  //   display: none !important;//去掉高德地图logo
  // }
  // ::v-deep .amap-copyright{
  //   display: none;
  // }
</style>